import React, { useState, useMemo, useEffect } from 'react'
import { View, TouchableOpacity } from 'react-native'
import PropTypes from 'prop-types'
import Card from '../../../../Card'
import Txt from '../../../../Txt'
import Divider from '../../../../Divider'
import StopItem from './StopItem'
import useStyles from './useStyles'
import { useTheme } from '../../../../../theming/ThemeProvider'
import IconButton from '../../../../IconButton'

const StopsCard = (props) => {
  const { load } = props
  const [showStops, setShowStops] = useState(false)
  const { theme } = useTheme()
  const styles = useStyles(theme)

  useEffect(() => {
    setShowStops(false)
  }, [load])

  const showStopsNumber = useMemo(() => !showStops && load?.stops && load?.stops.length, [load.stops, showStops])

  return (
    <Card containerStyle={styles.card} contentStyle={[styles.cardContent, showStops && { paddingBottom: 0 }]}>
      <StopItem
        stop={load?.origin}
        isOrigin
      />
      <View style={styles.dividerContainer}>
        <Divider containerStyle={styles.divider} />
        {Boolean(showStopsNumber) && (
          <TouchableOpacity activeOpacity={0.8} onPress={() => setShowStops(true)}>
            <View style={styles.stopsNumber}>
              <Txt
                text={load?.stops.length}
                identity='h4'
                color='COMPLETE_COLOR'
              />
            </View>
          </TouchableOpacity>
        )}
      </View>
      {showStops && load?.stops ? load?.stops.map((stop, key) => (
        <StopItem
          key={key}
          stop={stop}
          stopNumber={key + 1}
        />
      )) : null}
      <StopItem
        stop={load?.destination}
        isDestination
      />
      {showStops && (
        <View style={styles.closeArrow}>
          <IconButton
            icon='AngleUp'
            color='WHITE'
            iconColor='GEYSER'
            onPress={() => setShowStops(false)}
          />
        </View>
      )}
    </Card>
  )
}

StopsCard.propTypes = {
  load: PropTypes.object
}

StopsCard.defaultProps = {
  load: {}
}

export default StopsCard
